var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{class:_vm.loadingClasses,style:({ position: _vm.positionStyle, height: _vm.heightStyle })},[_c('div',{staticClass:"loading_center"},[_c('v-progress-circular',{attrs:{"color":"#0075c2","size":60,"width":5,"indeterminate":""}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }